import JSONStream from '@/script/JSONStream.mjs'
import Code from './Code.jsx'
import {isTable, Table} from './CustomTable.jsx'
import {isTree, Tree} from './CustomTree.jsx'

const getComponent = data => {
    if (isTable(data)) {
        return Table
    }
    else if (isTree(data)) {
        return Tree
    }
    else {
        return null
    }
}

export default function CustomElement({children, ...props}) {
    if (! children) {
        return null
    }

    try {
        const json = (new JSONStream).update(
            children?.replace(/(\n``)?\n$/, '')
        )

        const d = JSON.parse(json)

        if (Array.isArray(d)) {
            return d.map((e, i) => {
                const Component = getComponent(e)

                if (Component) {
                    return (
                        <Component
                            key={i}
                            data={e}
                            {...props}
                        />
                    )
                }
                else {
                    return (
                        <Code
                            key={i}
                            language="json"
                            {...props}
                        >
                            {JSON.stringify(e, null, 2)}
                        </Code>
                    )
                }
            })
        }
        else {
            const Component = getComponent(d)

            if (Component) {
                return (
                    <Component
                        data={d}
                        {...props}
                    />
                )
            }
            else {
                return (
                    <Code
                        language="json"
                        {...props}
                    >
                        {JSON.stringify(d, null, 2)}
                    </Code>
                )
            }
        }
    }
    catch (err) {
        ;
    }

    return (
        <Code
            language="json"
            {...props}
        >
            {children}
        </Code>
    )
}
